import { PostState } from './post.state';
import { initialNewPostState, NewPostState } from './new-post.state';
import { initialPostFormState, PostFormState } from './post-form.state';
import { PostPaginationModel } from '../../../shared/data/models/post-pagination.model';
import { SocialUserModel } from '../../../shared/data/models/social-user.model';

export interface HomeState {
  postFormState: PostFormState;
  postsState: PostState[];
  postPagination: PostPaginationModel;
  newPostState: NewPostState;

  feedLoading: boolean;
  feedError: string;

  feedLoadMoreError: string;

  echoLoading: boolean;
  echoError: string;

  socialUser: SocialUserModel;
}

export const initialHomeState: HomeState = {
  postFormState: { ...initialPostFormState },
  postsState: [],
  postPagination: null,
  newPostState: { ...initialNewPostState },
  feedLoading: false,
  feedError: '',
  feedLoadMoreError: '',

  echoLoading: false,
  echoError: '',

  socialUser: null
};
